export const LEAVE_ERROR_EMPLOYEE_BOOKED_ON_DATES = 'employeeIsBookedOnTheseDates';
export const LEAVE_ERROR_INSUFFICIENT_FUNDS_WILL_GO_NEGATIVE = 'insufficientFundsWillGoNegative';
export const LEAVE_ERROR_WILL_EXCEED_MONTHLY_EARNINGS_LIMIT = 'leaveWillExceedMonthlyEarningsLimit';
export const CONFIRMABLE_LEAVE_ERRORS = [
  LEAVE_ERROR_EMPLOYEE_BOOKED_ON_DATES,
  LEAVE_ERROR_INSUFFICIENT_FUNDS_WILL_GO_NEGATIVE,
  LEAVE_ERROR_WILL_EXCEED_MONTHLY_EARNINGS_LIMIT
];
